angular.module('impactx.search').controller('CategoryFilterSelectionCtrl', [
    '$timeout',
    'orderByFilter',
    CategoryFilterSelectionCtrl]);

function CategoryFilterSelectionCtrl($timeout, orderByFilter) {
    var self = this;
    self.searchText = '';
    self.cachedSelectedItem = {};

    self.getEntries = function () {
        if (self.ngModel) {
            self.searchText = self.ngModel.value;
        }
        else {
            self.searchText = '';
        }
        self.mdAutocompleteCtrl.hidden = false;

        return orderByFilter(self.items, 'value');
    };

    self.setSelectedItem = function (entry) {
        var element = angular.element('#' + self.inputName);
        element.blur();
        self.mdAutocompleteCtrl.hidden = true;

        if (entry) {
            if (angular.isFunction(self.onItemChange)) {
                self.onItemChange({selected: entry});
            }
        }
    };

    self.onFocus = function () {
        self.searchText = "";
        if (self.ngModel) {
            self.searchText = self.ngModel.value;
        }
    };

    self.openPopupFilter = function () {
        $timeout(function () {
            angular.element('#' + self.inputName).focus();
        }, 0);
    };

    self.clear = function (event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        var element = angular.element('#' + self.inputName);
        element.blur();

        self.mdAutocompleteCtrl.hidden = true;
        self.ngModel = null;
        self.searchText = '';
        if (angular.isFunction(self.onItemChange)) {
            self.onItemChange({selected: null});
        }
    }
}